import { createSelector } from 'reselect';

const getMultiselectState = (state) => state.multiselect;

export const getSelectedItems = (target) =>
  createSelector(getMultiselectState, (state) => state[target] ?? {});
